/* React */
import React, { useEffect } from "react";

/* React-Redux */
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";

import {
  setStartPoint,
  setShowConfidenceIntervals,
  setShowNoValueEntries,
} from "src/redux/features/insights-options/survival-analysis/survivalAnalysisOptionsSlice";

/* Thunks */
import { fetchStartPoints } from "src/redux/thunks/survival-analysis/survivalAnalysisThunk";

/* Components */
import ConfidenceInterval from "src/components/insights/insights-options/survival-analysis/confidence-interval/ConfidenceInterval";
import ShowNoValueEntries from "src/components/insights/insights-options/descriptive-statistics/show-no-value-entries/ShowNoValueEntries";

/* Hooks */
import { useIsCustomCohortActive } from "src/utils/hooks/useIsCustomCohortActive";

/* Constants */
import { StartPointType } from "src/shared/constants/survival-analysis/StartPoint";

/* Stylesheet */
import styles from "./SurvivalAnalysisOptions.module.scss";

/* Interfaces */
import SimpleSelect from "src/components/shared/simple-select/SimpleSelect";

const SurvivalPlotOptions: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const survivalAnalysisOptionsState = useSelector(
    (state: RootState) => state.survivalAnalysisOptions
  );

  const {
    startPoint,
    showConfidenceIntervals,
    showNoValueEntries,
  } = survivalAnalysisOptionsState;

  const isCustomCohortActive = useIsCustomCohortActive();

  useEffect(() => {
    dispatch(fetchStartPoints());
  }, [dispatch]);

  return (
    <div className={styles.survival_analysis_options}>
      <SimpleSelect
        className={"dark"}
        value={startPoint.value}
        items={startPoint.items ?? []}
        getLabel={(item) => item}
        onSelect={(item) =>
          dispatch(
            setStartPoint(
              item ?? StartPointType.FIRST_DIAGNOSIS
            )
          )
        }
      />
      <ConfidenceInterval
        showConfidenceIntervals={showConfidenceIntervals}
        handleConfidenceIntervals={() =>
          dispatch(
            setShowConfidenceIntervals(
              !showConfidenceIntervals
            )
          )
        }
      />
      <ShowNoValueEntries
        showNoValueEntries={showNoValueEntries}
        disabled={isCustomCohortActive}
        handleShowNoValueEntries={() =>
          dispatch(
            setShowNoValueEntries(!showNoValueEntries)
          )
        }
      />
    </div>
  );
};

export default SurvivalPlotOptions;
